import React from "react";
import { TransferTransaction } from "model";
import { useUIState, DisabledPrompt } from "bcms-react";

import { SVGAsset } from "res";
import { TableView, TableColumnContainer, TableItemView, TableItemTextView, FormContainer, FormRowView, TableHeaderView } from "components/shared";
import CustomTableAccordion, { CustomTableToggle, CustomTableContent, useCustomTableAccordion } from "components/custom-ui/CustomTableAccordion";
import MobileTransferHistoryTable from "../MobileTransferHistoryTable";

import "./styles.css";
import "./mobile.css";

export default function TransferHistoryPage(props) {
    const transfers = TransferTransaction.initAll().filter(transfer => transfer.status !== "scheduled" && transfer.status !== "", []);

    return (
        <div className="transfer-history-page">
            <div className="show-on-desktop">
                <TransferHistoryTable transfers={ transfers } />
            </div>

            <MobileTransferHistoryTable transfers={ transfers } />
        </div>
    )
}

function TransferHistoryTable(props) {
    const transfers = props.transfers ?? [];
    const transferRows = transfers.map(transfer => {
        return <TransferHistoryItem key={ `Transfer_History_${ transfer.id }`} transfer={ transfer } />
    }, []);

    return (
        <TableView className="transfer-history-table">
          <TableColumnContainer className="transfer-history-header">
            <th>&nbsp;</th>
            <th className="text-left">Tracking ID</th>
            <th className="text-left">
                From
                <DisabledPrompt>
                    <SVGAsset id="SortIcon" className="sort-icon clickable" />
                </DisabledPrompt>
            </th>
            <th className="text-left">
                To
                <DisabledPrompt>
                    <SVGAsset id="SortIcon" className="sort-icon clickable" />
                </DisabledPrompt>
            </th>
            <th className="text-left">
                Transfer Date
                <DisabledPrompt>
                    <SVGAsset id="ArrowDownIcon" className="sort-icon clickable" />
                </DisabledPrompt>
            </th>
            <th className="text-left">
                Completion Date
                <DisabledPrompt>
                    <SVGAsset id="SortIcon" className="sort-icon clickable" />
                </DisabledPrompt>
            </th>
            <th className="text-left">
                Status
                <DisabledPrompt>
                    <SVGAsset id="SortIcon" className="sort-icon clickable" />
                </DisabledPrompt>
            </th>
            <th className="text-left">
                Amount
                <DisabledPrompt>
                    <SVGAsset id="SortIcon" className="sort-icon clickable" />
                </DisabledPrompt>    
            </th>
          </TableColumnContainer>
    
          <tbody>
            <TableHeaderView text="Processed" colSpan="8" dataPoint="Transfer_History_Processed_Header" />
          </tbody>
          {transferRows}
    
        </TableView>
      );
}

function TransferHistoryItem(props) { 
    const transfer = props.transfer ?? TransferTransaction.firstInstanceOf();
    const { key, config } = useUIState(`Accordion_${ transfer.id }`, { isActive: false });

    return (
        <CustomTableAccordion activeClass="open-table-accordion" active={ config.isActive }>
            <TransferHistoryItemToggle transfer={ transfer } />
            <TransferHistoryItemContent transfer={ transfer } />
        </CustomTableAccordion>
    )
}

function TransferHistoryItemToggle(props) {
    const transfer = props.transfer ?? TransferTransaction.firstInstanceOf();
    const { state } = useCustomTableAccordion();

    return (
        <CustomTableToggle>
            <tr>
                <TableItemView className="expand-chevron-icon text-center expanded">
                    <SVGAsset id={state ? "DownChevronIcon" : "RightChevronIcon"} className="icon" />
                </TableItemView>

                <TableItemTextView className="text-left expanded" text={ transfer.mapID } />
                <TableItemTextView className="text-left expanded" text={ transfer.from.nickname +" - " + transfer.from.number } />
                <TableItemTextView className="text-left expanded" text={ transfer.to.nickname +" - " + transfer.to.number } />
                <TableItemTextView className="text-left expanded" text={ transfer.onDate.format("m/d/Y") } />
                <TableItemTextView className="text-left expanded" text={ transfer.onDate.format("m/d/Y") }  />
                
                <TableItemView className="expanded status-column">
                    <div className="flex-container">
                        <SVGAsset id="CircleCheckmarkIcon" className="icon inline-text-icon checkmark-icon left-icon" />
                        <p>{transfer.status} </p>
                    </div>
                </TableItemView>
                
                <TableItemTextView className="text-right expanded amount-column" text={transfer.amount.format()} />
            </tr>
        </CustomTableToggle>
    )
}

function TransferHistoryItemContent(props) {
    const transfer = props.transfer ?? TransferTransaction.firstInstanceOf();

    return (
        <CustomTableContent>
            <tr>
                <td className="transfer-history-table-item" colSpan="8">
                    <div className="flex-container">
                        <p className="flex-width">TRANSFER DETAILS</p>
                        <CustomTableToggle>
                            <SVGAsset id="CloseX" className="set-width clickable" />
                        </CustomTableToggle>
                    </div>
                    
                    <FormContainer>
                        <FormRowView text="Note">
                            <p>{ transfer.note }</p>
                        </FormRowView>
                    </FormContainer>
                </td>
            </tr>
        </CustomTableContent>
    )
}